import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const SeverityPillRoot = styled('span')(({ theme, colorEnviado }) => {
    const backgroundColor = colorEnviado;
    
    return {
        alignItems: 'center',
        backgroundColor: backgroundColor,
        borderRadius: 12,
        color: 'white',
        cursor: 'default',
        display: 'inline-flex',
        flexGrow: 0,
        flexShrink: 0,
        marginRight: 4,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(10),
        lineHeight: 2,
        fontWeight: 550,
        justifyContent: 'center',
        letterSpacing: 0.1,
        minWidth: 20,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
    };
});

export const SeverityPill = (props) => {
    const { color, texto} = props;


    return (
        <SeverityPillRoot
            colorEnviado={color}
        >
        {texto}
        </SeverityPillRoot>
    );
};

